<template>
  <div class="leads">
    <h1>📋 线索库</h1>

    <!-- 线索库 Tab：全部线索 / 意向用户 / 已互关建联 / 私域 / 数据日历（2026-08-31 功能合并） -->
    <el-tabs v-model="activeTab" class="leads-tabs">
      <el-tab-pane label="全部线索" name="all">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>潜在客户列表</span>
          <div>
            <el-select v-model="statusFilter" placeholder="按状态筛选" clearable style="width: 140px; margin-right: 10px;">
              <el-option label="新线索" value="new" />
              <el-option label="已联系" value="contacted" />
              <el-option label="已意向" value="qualified" />
              <el-option label="已转化" value="converted" />
            </el-select>
            <el-select v-model="platformFilter" placeholder="按平台筛选" clearable style="width: 140px; margin-right: 10px;">
              <el-option label="抖音" value="douyin" />
              <el-option label="抖音(直播)" value="douyin_live" />
              <el-option label="快手" value="kuaishou" />
            </el-select>
            <el-select v-model="scoreFilter" placeholder="按意向分" clearable style="width: 130px; margin-right: 10px;">
              <el-option label="A级(≥4)" :value="4" />
              <el-option label="B级(≥2.5)" :value="2.5" />
              <el-option label="C级(≥1)" :value="1" />
            </el-select>
            <el-select v-model="sourceKeywordFilter" placeholder="来源关键词" clearable filterable style="width: 150px; margin-right: 10px;">
              <el-option v-for="kw in sourceKeywords" :key="kw" :label="kw" :value="kw" />
            </el-select>
            <el-select v-model="accountFilter" placeholder="获取账号" clearable style="width: 130px; margin-right: 10px;">
              <el-option v-for="acc in accounts" :key="acc.id" :label="'账号' + acc.id + (acc.nickname ? '·' + acc.nickname : '')" :value="acc.id" />
            </el-select>
            <el-date-picker v-model="dateRange" type="daterange" value-format="YYYY-MM-DD"
              range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
              style="width: 250px; margin-right: 10px;" />
            <el-button type="primary" @click="loadLeads">刷新</el-button>
            <el-button @click="showManualAdd = true">📝 手工录入</el-button>
            <el-button @click="exportExcel">📥 导出Excel</el-button>
            <el-button type="success" :disabled="!selectedLeads.length" @click="showFollowupDialog = true">
              📦 批量跟进（{{ selectedLeads.length }}）
            </el-button>
          </div>
        </div>
      </template>

      <el-table :data="leads" style="width: 100%" v-loading="loading" @selection-change="sel => selectedLeads = sel">
        <el-table-column type="selection" width="45" />
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="采集时间" width="160">
          <template #default="scope">
            <span :title="scope.row.created_at">{{ scope.row.created_at || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.platform === 'kuaishou' ? 'warning' : ''" size="small">
              {{ platformText(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="抖音号" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column label="评论内容（来源）" min-width="220">
          <template #default="scope">
            <template v-if="scope.row.notes">
              <div class="lead-notes" :title="scope.row.notes">{{ scope.row.notes }}</div>
              <el-link v-if="scope.row.source_url" type="primary" :href="scope.row.source_url" target="_blank" size="mini">
                🔗 原视频/主页
              </el-link>
            </template>
            <span v-else style="color:#bbb">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="评分">
          <template #default="scope">
            <el-rate v-model="scope.row.score" disabled show-score score-template="{value}" />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="source_keyword" label="来源关键词" />
        <el-table-column prop="tags" label="标签">
          <template #default="scope">
            <el-tag v-for="tag in scope.row.tags" :key="tag" size="small" class="tag-item">
              {{ tag }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="📤 发送记录" min-width="220">
          <template #default="scope">
            <template v-if="scope.row.send_records && scope.row.send_records.length">
              <div v-for="(rec, i) in scope.row.send_records" :key="i" class="send-record">
                <el-tag :type="rec.action === 'dm' ? 'danger' : (rec.action === 'follow' ? 'warning' : 'info')" size="mini">
                  {{ rec.action_label }}
                </el-tag>
                <span class="rec-time">{{ rec.created_at }}</span>
                <div class="rec-content" :title="rec.content">{{ rec.content }}</div>
              </div>
            </template>
            <span v-else style="color:#bbb">—</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button size="small" @click="viewLead(scope.row)">查看</el-button>
            <el-select
              v-model="scope.row.status"
              size="small"
              style="width: 100px;"
              @change="updateStatus(scope.row)"
            >
              <el-option label="新线索" value="new" />
              <el-option label="已联系" value="contacted" />
              <el-option label="已意向" value="qualified" />
              <el-option label="已转化" value="converted" />
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
      </el-tab-pane>

      <!-- 🔥 意向用户（原 /intent 页） -->
      <el-tab-pane label="🔥 意向用户" name="intent">
        <IntentLeads />
      </el-tab-pane>

      <!-- 🤝 已互关/建联（原 /ledger 页） -->
      <el-tab-pane label="🤝 已互关/建联" name="ledger">
        <Ledger />
      </el-tab-pane>

      <!-- 💬 私域管理（原 /private 页） -->
      <el-tab-pane label="💬 私域管理" name="private">
        <PrivatePage />
      </el-tab-pane>

      <!-- 📅 数据日历（原 /calendar 页） -->
      <el-tab-pane label="📅 数据日历" name="calendar">
        <DataCalendar />
      </el-tab-pane>
    </el-tabs>

    <!-- 📝 手工录入对话框（原 /manual-add 页） -->
    <el-dialog v-model="showManualAdd" title="📝 手工录入账号" width="720px" destroy-on-close>
      <ManualAdd />
    </el-dialog>

    <el-drawer v-model="drawerVisible" size="520px" :title="drawerTitle">
      <div v-if="drawerLead" class="drawer-body">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="平台">{{ platformText(drawerLead.platform) }}</el-descriptions-item>
          <el-descriptions-item label="评分">
            <el-rate v-model="drawerLead.score" disabled show-score score-template="{value}" />
          </el-descriptions-item>
          <el-descriptions-item label="昵称">{{ drawerLead.nickname || '—' }}</el-descriptions-item>
          <el-descriptions-item label="抖音号">{{ drawerLead.username }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusText(drawerLead.status) }}</el-descriptions-item>
          <el-descriptions-item label="来源关键词">{{ drawerLead.source_keyword || '—' }}</el-descriptions-item>
          <el-descriptions-item label="来源同行账号" :span="2">
            <template v-if="drawerLead.blogger_name">
              {{ drawerLead.blogger_name }}
              <el-link v-if="drawerLead.blogger_url" type="primary" :href="drawerLead.blogger_url" target="_blank" style="margin-left:8px;">👀 查看同行主页</el-link>
            </template>
            <span v-else style="color:#bbb">—</span>
          </el-descriptions-item>
          <el-descriptions-item label="采集时间" :span="2">{{ drawerLead.created_at || '—' }}</el-descriptions-item>
          <el-descriptions-item label="标签" :span="2">
            <el-tag v-for="tag in (drawerLead.tags||[])" :key="tag" size="small" class="tag-item">{{ tag }}</el-tag>
            <span v-if="!(drawerLead.tags||[]).length">—</span>
          </el-descriptions-item>
        </el-descriptions>

        <h4 style="margin:16px 0 8px;">💬 评论原文（来源）</h4>
        <div class="drawer-notes">{{ drawerLead.notes || '—' }}</div>
        <div style="margin-top:8px;">
          <el-link v-if="drawerLead.source_url" type="primary" :href="drawerLead.source_url" target="_blank">
            🔗 打开原视频/主页（查看评论区）
          </el-link>
          <span v-else style="color:#bbb">无来源链接</span>
        </div>

        <h4 style="margin:16px 0 8px;">📤 发送/互动记录</h4>
        <template v-if="drawerLead.send_records && drawerLead.send_records.length">
          <div v-for="(rec, i) in drawerLead.send_records" :key="i" class="send-record">
            <el-tag :type="rec.action === 'dm' ? 'danger' : (rec.action === 'follow' ? 'warning' : 'info')" size="mini">
              {{ rec.action_label }}
            </el-tag>
            <el-tag v-if="rec.status === 'sent'" type="success" size="mini">成功</el-tag>
            <el-tag v-else-if="rec.status === 'failed'" type="danger" size="mini">失败</el-tag>
            <span class="rec-time">{{ rec.created_at }}</span>
            <div class="rec-content">{{ rec.content }}</div>
          </div>
        </template>
        <span v-else style="color:#bbb">—</span>
      </div>
    </el-drawer>

    <!-- 批量跟进 Dialog（2026-08-30：对齐阿里山方式二，4 种跟进方式） -->
    <el-dialog v-model="showFollowupDialog" title="📦 批量跟进" width="560px">
      <el-form :model="followupForm" label-width="110px">
        <el-form-item label="执行账号">
          <el-select v-model="followupForm.account_id" style="width: 100%">
            <el-option
              v-for="account in accounts"
              :key="account.id"
              :label="`${account.username} (${account.nickname})${account.is_logged_in ? ' ✅已登录' : ''}`"
              :value="account.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进方式">
          <el-radio-group v-model="followupForm.mode">
            <el-radio value="comment_first_work">💬 主页首作品评论</el-radio>
            <el-radio value="follow_dm">🤝 关注+私信</el-radio>
            <el-radio value="follow_only">➕ 仅关注</el-radio>
            <el-radio value="dm_only">✉️ 仅私信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="['follow_dm','dm_only'].includes(followupForm.mode)" label="私信话术">
          <el-input
            v-model="followupForm.dm_text"
            type="textarea"
            :rows="3"
            placeholder="留空则按下方话术阶段 AI 自动生成（推荐）"
          />
        </el-form-item>
        <el-form-item v-if="['follow_dm','dm_only'].includes(followupForm.mode)" label="话术阶段">
          <el-select v-model="followupForm.stage" style="width: 100%" placeholder="自动（按线索意向分匹配）">
            <el-option label="🤖 自动匹配（按意向分）" value="" />
            <el-option label="① 初识破冰（首次触达）" value="intro" />
            <el-option label="② 需求确认（是否真有需求）" value="qualify" />
            <el-option label="③ 价值主张（产品核心价值）" value="value" />
            <el-option label="④ 需求挖掘（开放式提问）" value="needs" />
            <el-option label="⑤ 方案展示（方案+案例）" value="solution" />
            <el-option label="⑥ 异议处理（打消顾虑）" value="objection" />
            <el-option label="⑦ 促单成交（报价/方案/到店）" value="close" />
            <el-option label="⑧ 礼貌收尾（保持联系）" value="end" />
          </el-select>
          <span style="color:#909399;font-size:12px">借鉴 SalesGPT 8 阶段销售流程：高意向(≥4分)自动用方案/成交话术，低意向用初识/资格话术</span>
        </el-form-item>
        <el-form-item label="间隔时间">
          <el-input-number v-model="followupForm.interval_lo" :min="10" :max="300" :step="10" /> 秒 ~
          <el-input-number v-model="followupForm.interval_hi" :min="20" :max="600" :step="10" /> 秒
          <span style="margin-left:8px;color:#909399;font-size:12px">拟人化间隔，建议 ≥30s 防关联风控</span>
        </el-form-item>
        <el-form-item label="最多处理">
          <el-input-number v-model="followupForm.max_leads" :min="1" :max="50" />
          <span style="margin-left:8px;color:#909399;font-size:12px">已勾选 {{ selectedLeads.length }} 条</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showFollowupDialog = false">取消</el-button>
        <el-button type="success" :loading="followupSending" @click="submitBatchFollowup">开始执行</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../api'
import IntentLeads from './IntentLeads.vue'
import Ledger from './Ledger.vue'
import PrivatePage from './Private.vue'
import DataCalendar from './DataCalendar.vue'
import ManualAdd from './ManualAdd.vue'

export default {
  name: 'Leads',
  components: { IntentLeads, Ledger, PrivatePage, DataCalendar, ManualAdd },
  data() {
    return {
      activeTab: 'all',
      showManualAdd: false,
      searchQuery: '',
      statusFilter: '',
      loading: false,
      leads: [],
      platformFilter: '',
      scoreFilter: null,
      sourceKeywordFilter: '',
      accountFilter: null,
      dateRange: null,
      sourceKeywords: [],
      drawerVisible: false,
      drawerLead: null,
      selectedLeads: [],
      showFollowupDialog: false,
      followupSending: false,
      accounts: [],
      followupForm: {
        account_id: null,
        mode: 'follow_dm',
        dm_text: '',
        stage: '',
        interval_lo: 30,
        interval_hi: 60,
        max_leads: 20
      }
    }
  },
  computed: {
    drawerTitle() {
      return this.drawerLead ? `线索详情 - ${this.drawerLead.username || this.drawerLead.nickname || ''}` : '线索详情'
    }
  },
  created() {
    // 旧链接重定向：/intent /ledger /private /calendar /manual-add → ?tab=xxx
    const t = this.$route.query.tab
    const valid = ['intent', 'ledger', 'private', 'calendar', 'manual']
    if (t && valid.includes(t)) {
      this.activeTab = t === 'manual' ? 'all' : t
      if (t === 'manual') this.showManualAdd = true
    } else if (window.innerWidth < 768) {
      // 手机端默认展示「意向用户」页（最值得关注的转化线索），PC 保持「全部线索」
      this.activeTab = 'intent'
    }
    this.loadLeads()
    this.loadAccounts()
  },
  methods: {
    async exportExcel() {
      try {
        const params = []
        if (this.statusFilter) params.push(`status=${this.statusFilter}`)
        if (this.platformFilter) params.push(`platform=${this.platformFilter}`)
        const qs = params.length ? '?' + params.join('&') : ''
        // 直接浏览器下载（后端返回 xlsx 附件）
        window.open(`/api/v1/leads/export-excel${qs}`, '_blank')
      } catch (e) {
        this.$message.error('导出失败: ' + e.message)
      }
    },
    async loadAccounts() {
      try {
        this.accounts = await api.get('/accounts/')
      } catch (e) {
        // 静默
      }
    },
    async submitBatchFollowup() {
      if (!this.followupForm.account_id) {
        this.$message.warning('请选择执行账号')
        return
      }
      if (!this.selectedLeads.length) {
        this.$message.warning('请先勾选要跟进的线索')
        return
      }
      this.followupSending = true
      try {
        const r = await api.post('/leads/batch-followup', {
          account_id: this.followupForm.account_id,
          lead_ids: this.selectedLeads.map(l => l.id),
          mode: this.followupForm.mode,
          dm_text: this.followupForm.dm_text || '',
          stage: this.followupForm.stage || '',
          interval_lo: this.followupForm.interval_lo,
          interval_hi: this.followupForm.interval_hi,
          max_leads: this.followupForm.max_leads
        })
        this.$message.success(r.message || '批量跟进已提交')
        this.showFollowupDialog = false
      } catch (e) {
        this.$message.error('提交失败: ' + e.message)
      } finally {
        this.followupSending = false
      }
    },
    async loadLeads() {
      this.loading = true
      try {
        const params = {}
        if (this.statusFilter) params.status = this.statusFilter
        if (this.platformFilter) params.platform = this.platformFilter
        if (this.scoreFilter) params.min_score = this.scoreFilter
        if (this.sourceKeywordFilter) params.source_keyword = this.sourceKeywordFilter
        if (this.accountFilter) params.account_id = this.accountFilter
        if (this.dateRange && this.dateRange.length === 2) {
          params.date_from = this.dateRange[0]
          params.date_to = this.dateRange[1]
        }
        this.leads = await api.get('/leads/', { params })
        // 收集来源关键词列表（下拉选项）
        const kws = new Set()
        this.leads.forEach(l => { if (l.source_keyword) kws.add(l.source_keyword) })
        this.sourceKeywords = [...kws].slice(0, 30)
      } catch (e) {
        this.$message.error('加载线索失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    platformText(p) {
      const map = { douyin: '抖音', kuaishou: '快手', xhs: '小红书', douyin_live: '抖音直播', kuaishou_live: '快手直播' }
      return map[p] || p || '抖音'
    },
    getStatusType(status) {
      const map = {
        new: 'info',
        contacted: 'warning',
        qualified: 'success',
        converted: 'primary'
      }
      return map[status] || 'info'
    },
    statusText(status) {
      const map = {
        new: '新线索',
        contacted: '已联系',
        qualified: '已意向',
        converted: '已转化'
      }
      return map[status] || status
    },
    viewLead(lead) {
      this.drawerLead = lead
      this.drawerVisible = true
    },
    async updateStatus(lead) {
      try {
        await api.put(`/leads/${lead.id}/status`, { status: lead.status })
        this.$message.success('状态已更新')
      } catch (e) {
        this.$message.error('更新失败: ' + e.message)
        this.loadLeads()
      }
    }
  }
}
</script>

<style scoped>
.leads {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 手机端优化 */
@media (max-width: 767px) {
  .leads { padding: 10px; }
  .card-header { flex-direction: column; align-items: flex-start; gap: 8px; }
  .card-header > div { display: flex; flex-wrap: wrap; gap: 6px; }
  .card-header .el-select { width: 100% !important; margin-right: 0 !important; }
  .el-table { overflow-x: auto; }
}

.tag-item {
  margin-right: 4px;
}

.lead-notes {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.send-record {
  padding: 3px 0;
  border-bottom: 1px dashed #eee;
}

.send-record:last-child {
  border-bottom: none;
}

.rec-time {
  margin-left: 6px;
  font-size: 12px;
  color: #999;
}

.rec-content {
  margin-top: 2px;
  font-size: 12px;
  color: #666;
  white-space: normal;
  word-break: break-all;
  max-width: 460px;
}

.drawer-body {
  padding: 0 8px;
}

.drawer-notes {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
  background: #f7f8fa;
  border-radius: 6px;
  padding: 10px 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
